import { mapValues } from "lodash";

export default selectorMap => state =>
  mapValues(selectorMap, selector => selector(state));
